import { AppShell, BackgroundImage, Box, Container, Flex, Stack, Text } from '@mantine/core';
import classes from './AuthLayout.module.css';
import { usePage, Head } from '@inertiajs/react';
import auth_layer_bg from "../../assets/img/auth_layer_bg.svg";
import { Logo, LanguageSwitcher } from '../ui';
import { useTranslation } from 'react-i18next';

export default function ({ children, pageTitle = null }) {

    const { t } = useTranslation();
    const { appName, pageTitle: backendPageTitle = null } = usePage().props;

    const finalPageTitle = backendPageTitle && backendPageTitle.trim() !== '' ? backendPageTitle : pageTitle;

    return (
        <>
            <Head title={`${finalPageTitle ?? ''} - ${appName}`} />
            <AppShell className={classes.layout}>
                <AppShell.Main>
                    <BackgroundImage
                        src={auth_layer_bg}
                        className={classes.background_image}
                    >
                        <Container mih="100vh">
                            <Stack
                                mih="100vh"
                                h="100%"
                                align="stretch"
                                justify="space-between"
                                gap="md"
                                className={classes.content}
                            >
                                <Box px="md" mt={{ base: 45, sm: 'xl' }} mb={{ base: 0, sm: 'xl' }}>
                                    <Flex justify="center" align="center" direction="row" gap="md">
                                        <Logo type="studio" h={{ base: 48, sm: 40 }} maw="100%" fit="contain" lightOnly={true}/>
                                    </Flex>
                                    <Flex justify="flex-end">
                                        <LanguageSwitcher />
                                    </Flex>
                                </Box>

                                <Box>
                                    {children}
                                </Box>
                                <Box mt={{ base: 'auto', sm: 'xl' }} mb="xl">
                                    <Text ta="center" fz={{ base: 14, sm: 'md' }} c={{ base: 'gray.7', sm: 'figma-grey.4' }}>
                                        {t('layout.needHelp')} <Text span fz={{ base: 14, sm: 'md' }} td={{ base: 'none', sm: 'underline' }} fw={{ base: 400, sm: 700 }} c={{ base: 'black', sm: 'figma-grey.7' }} component="a" href="mailto:clients@smartico.one">{t('layout.contactUs')}</Text>
                                    </Text>
                                </Box>
                            </Stack>
                        </Container>
                    </BackgroundImage>
                </AppShell.Main>
            </AppShell>
        </>
    )
}